import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  const $table = $('.table')
  debugLogScriptName($table, 'select-all.js')
  $table.on('click', '[data-function="select-all"]', function() {
    const index = $(this).index()
    const checked = $('tr')
      .eq(1)
      .find('td')
      .eq(index)
      .find('input[type="checkbox"]')
      .prop('checked')

    $('tr').each(function() {
      $(this)
        .find('td')
        .eq(index)
        .find('input[type="checkbox"]')
        .prop('checked', !checked)
    })
  })
})
